<template>
  <ul>
    <template v-for="(comment, ci) in value">
    <li v-if="comment.parent==null">
      <div class="type" v-on:click.prevent="openReply(ci)">Reply</div>
      <div class="author"><span>{{ comment.author.firstname+" "+comment.author.lastname }}</span></div>
      <div class="auth-img"><img :src="photoLink(comment.author.media)" /></div>
      <div class="comment-text" v-html="escapeText(comment.content)"></div>
      <time>{{ formatDate(comment.created, "MMM Do, YYYY [at] h:mm a") }}</time>
      <a class="remove" v-on:click.prevent="remove(ci)"></a>
    </li>
    <li v-for="(comment2, ci2) in value" v-if="comment2.parent==comment.id" class="reply">
      <div class="author"><span>{{ comment2.author.firstname+" "+comment2.author.lastname }}</span></div>
      <div class="auth-img"><img :src="photoLink(comment2.author.media)" /></div>
      <div class="comment-text" v-html="escapeText(comment2.content)"></div>
      <time>{{ formatDate(comment2.created, "MMM Do, YYYY [at] h:mm a") }}</time>
      <a class="remove" v-on:click.prevent="remove(ci2)"></a>
    </li>
    <li class="form reply" v-if="replyId==comment.id">
      <div class="type">Leave a Reply</div>
      <div class="auth-img"><img :src="photoLink(currentUser.media)" /></div>
      <form v-on:submit.prevent="submitReply">
        <textarea ref="replyBox" v-model="replyComment"></textarea>
        <button>Send</button>
      </form>
    </li>
    </template>
    <li class="form">
      <div class="type">Leave a Comment</div>
      <div class="auth-img"><img :src="photoLink(currentUser.media)" /></div>
      <form v-on:submit.prevent="submitComment">
        <textarea ref="commentBox" v-model="newComment"></textarea>
        <button>Send</button>
      </form>
    </li>
  </ul>
</template>

<script>
import moment from 'moment';
import api from './api';
export default {
  props: ["value", "item"],
  data: ()=>({
    replyId: null,
    replyComment: "",
    newComment: "",
    currentUser: {},
  }),
  mounted() {
    this.loadCurrentUser();
  },
  methods: {
    async loadCurrentUser() {
      if (window.appRoot.loggedIn)
        this.currentUser=(await api.get("User", window.appRoot.loggedIn.id)).item;
      else
        this.$router.replace({name: "user.login"});
    },
    openReply(index) {
      this.replyComment="";
      this.replyId=this.value[index].id;
      this.$nextTick(()=>{
        this.$refs.replyBox[0].focus();
      });
    },
    async submitReply() {
      var newComment=(await api.create("Comment", {
        created: "CURRENT_TIMESTAMP",
        author: this.currentUser.id,
        parent: this.replyId,
        post: this.item.id,
        content: this.replyComment,
      }, true)).item;
      this.replyComment="";
      this.replyId=null;
      var newComments=this.value.slice();
      newComments.push(newComment);
      this.$emit("input", newComments);
    },
    async submitComment() {
      var newComment=(await api.create("Comment", {
        created: "CURRENT_TIMESTAMP",
        author: this.currentUser.id,
        parent: null,
        post: this.item.id,
        content: this.newComment,
      }, true)).item;
      this.newComment="";
      var newComments=this.value.slice();
      newComments.push(newComment);
      this.$emit("input", newComments);
    },
    async remove(index) {
      if (!confirm("Are you sure?"))
        return;
      var comment=this.value[index];
      if (comment && comment.id)
        await api.delete("Comment", comment.id);
      var newComments=this.value.slice();
      newComments.splice(index, 1);
      this.$emit("input", newComments);      
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    escapeText(text) {
      return (text || "")
        .replace(/&/g, "&amp;")
        .replace(/\</g, "&lt;")
        .replace(/\>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/\n/g, "<br />\n");
    },
    formatDate(date, format) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
  },
}
</script>
